import type { IMetadata } from '@adloid-technologies/discover-sdk';

/**
 * GMC Terrain (linkId 2380, project 59).
 *
 * Converted from the 1.0 repo's `src/metadata/data/metadata-2380.ts`
 * (`appData.visualiser.models[0]`, array-shaped) into the 2.0 object-keyed
 * `IMetadata` shape, following the conventions established for 2382/2377:
 * consolidate-or-split fingerprinting per entity, `autoIntelRPOCode` from
 * `brandItemCode`, real condition/isDefault/isStop threading on accessory
 * messages, model-level `hotspots` built from the default variant, and
 * `groupId`/`isDefault` derived from `removeAccessories` via connected
 * components (with single-select group categories normalised to the group's
 * dominant category — 1.0 sometimes mislabels one member).
 *
 * 1.0 gives both Elevation trims the SAME name, disambiguated only by
 * `descriptions` (AWD/FWD) — same pattern as 2378 Traverse's LT-AWD/LT-FWD
 * split. Variant keys here are elevation-awd/elevation-fwd accordingly.
 *
 * Generated — see the conversion notes in ui-metadata.ts.
 */
export const metadata: IMetadata = {
  models: {
    Terrain: {
      id: 'Terrain',
      lightingIdentifier: {
        interior: 'dome',
        exterior: 'dome',
      },
      postProcessingIdentifier: {
        interior: 'dome',
        exterior: 'dome',
      },
      backgroundIdentifer: 'dome',
      variants: {
        denali: {
          defaultSkus: [
            {
              id: 'common_exterior',
              sku: '5847',
              projectId: '59',
              position: [0, 0, 0],
            },
            {
              id: 'interior-color',
              sku: '5836',
              projectId: '59',
              position: [0, 0, 0],
            },
            {
              id: 'exterior-color',
              sku: '5834',
              projectId: '59',
              position: [0, 0, 0],
            },
            {
              id: 'variants_parts',
              sku: '5860',
              projectId: '59',
              position: [0, 0, 0],
            },
            {
              id: 'dome',
              sku: '7092',
              projectId: '59',
              position: [0, 0, 0],
              maxResolution: {
                ios: '2K',
                android: '4K',
              },
            },
          ],
          interiorColorIdentifier: 'interior-color',
          exteriorColorIdentifier: 'exterior-color',
        },
        at4: {
          defaultSkus: [
            {
              id: 'common_exterior',
              sku: '5847',
              projectId: '59',
              position: [0, 0, 0],
            },
            {
              id: 'interior-color',
              sku: '5859',
              projectId: '59',
              position: [0, 0, 0],
            },
            {
              id: 'exterior-color',
              sku: '5834',
              projectId: '59',
              position: [0, 0, 0],
            },
            {
              id: 'variants_parts',
              sku: '5858',
              projectId: '59',
              position: [0, 0, 0],
            },
            {
              id: 'alloys',
              sku: '5840',
              projectId: '59',
              position: [0, 0, 0],
            },
            {
              id: 'dome',
              sku: '7092',
              projectId: '59',
              position: [0, 0, 0],
              maxResolution: {
                ios: '2K',
                android: '4K',
              },
            },
          ],
          interiorColorIdentifier: 'interior-color',
          exteriorColorIdentifier: 'exterior-color',
        },
        'elevation-awd': {
          defaultSkus: [
            {
              id: 'common_exterior',
              sku: '5847',
              projectId: '59',
              position: [0, 0, 0],
            },
            {
              id: 'interior-color',
              sku: '5848',
              projectId: '59',
              position: [0, 0, 0],
            },
            {
              id: 'exterior-color',
              sku: '5834',
              projectId: '59',
              position: [0, 0, 0],
            },
            {
              id: 'variants_parts',
              sku: '5846',
              projectId: '59',
              position: [0, 0, 0],
            },
            {
              id: 'dome',
              sku: '7092',
              projectId: '59',
              position: [0, 0, 0],
              maxResolution: {
                ios: '2K',
                android: '4K',
              },
            },
          ],
          interiorColorIdentifier: 'interior-color',
          exteriorColorIdentifier: 'exterior-color',
        },
        'elevation-fwd': {
          defaultSkus: [
            {
              id: 'common_exterior',
              sku: '5847',
              projectId: '59',
              position: [0, 0, 0],
            },
            {
              id: 'interior-color',
              sku: '5848',
              projectId: '59',
              position: [0, 0, 0],
            },
            {
              id: 'exterior-color',
              sku: '5834',
              projectId: '59',
              position: [0, 0, 0],
            },
            {
              id: 'variants_parts',
              sku: '5843',
              projectId: '59',
              position: [0, 0, 0],
            },
            {
              id: 'dome',
              sku: '7092',
              projectId: '59',
              position: [0, 0, 0],
              maxResolution: {
                ios: '2K',
                android: '4K',
              },
            },
          ],
          interiorColorIdentifier: 'interior-color',
          exteriorColorIdentifier: 'exterior-color',
        },
      },
      backgrounds: {
        g0ZA968_RpUd: {
          isDefault: true,
          sku: '7092',
          project: '59',
        },
        g0ZA968_RpUe: {
          isDefault: false,
          sku: '7091',
          project: '59',
        },
      },
      ambientLighting: {
        ambientColors: '',
        ambientLightings: {},
        relevantVariants: [],
      },
      colors: {
        exterior: {
          g946ignut6zm: {
            sku: '5834',
            project: '59',
            relevantVariants: [
              'denali',
            ],
          },
          '5zwfz8t9v1ci': {
            sku: '5838',
            project: '59',
            relevantVariants: [
              'denali',
            ],
          },
          '3bcwcix9d6ow': {
            sku: '5839',
            project: '59',
            relevantVariants: [
              'denali',
            ],
          },
          ekrnov29ywox: {
            sku: '5835',
            project: '59',
            relevantVariants: [
              'denali',
            ],
          },
          t97r2gqldscc: {
            sku: '5842',
            project: '59',
            relevantVariants: [
              'denali',
            ],
          },
          e12d2rs52b1b: {
            sku: '5845',
            project: '59',
            relevantVariants: [
              'denali',
            ],
          },
          cda85q0n704m: {
            sku: '5834',
            project: '59',
            relevantVariants: [
              'at4',
            ],
          },
          jn8my849khfa: {
            sku: '5837',
            project: '59',
            relevantVariants: [
              'at4',
            ],
          },
          '8xcbgkact0f0': {
            sku: '5839',
            project: '59',
            relevantVariants: [
              'at4',
            ],
          },
          '1kghn4i9l1el': {
            sku: '5835',
            project: '59',
            relevantVariants: [
              'at4',
            ],
          },
          ec4xrp8qgmc4: {
            sku: '5842',
            project: '59',
            relevantVariants: [
              'at4',
            ],
          },
          z04z5oe53ocg: {
            sku: '5844',
            project: '59',
            relevantVariants: [
              'at4',
            ],
          },
          '07cosz9zjv1c': {
            sku: '5834',
            project: '59',
            relevantVariants: [
              'elevation-awd',
            ],
          },
          tqyl606wwk4u: {
            sku: '5837',
            project: '59',
            relevantVariants: [
              'elevation-awd',
            ],
          },
          kmxu84eillx4: {
            sku: '5839',
            project: '59',
            relevantVariants: [
              'elevation-awd',
            ],
          },
          '0wgwmbez5v85': {
            sku: '5835',
            project: '59',
            relevantVariants: [
              'elevation-awd',
            ],
          },
          djljg0jbm4gf: {
            sku: '5842',
            project: '59',
            relevantVariants: [
              'elevation-awd',
            ],
          },
          '3ae636l3ri0b': {
            sku: '5844',
            project: '59',
            relevantVariants: [
              'elevation-awd',
            ],
          },
          '7eez7nplog7a': {
            sku: '5834',
            project: '59',
            relevantVariants: [
              'elevation-fwd',
            ],
          },
          dtjmzz3bsfrl: {
            sku: '5837',
            project: '59',
            relevantVariants: [
              'elevation-fwd',
            ],
          },
          ruym5z4zk7bp: {
            sku: '5839',
            project: '59',
            relevantVariants: [
              'elevation-fwd',
            ],
          },
          svfkt34o1vbs: {
            sku: '5835',
            project: '59',
            relevantVariants: [
              'elevation-fwd',
            ],
          },
          '2h6rvjratd39': {
            sku: '5842',
            project: '59',
            relevantVariants: [
              'elevation-fwd',
            ],
          },
          ys6fc5ecm0gr: {
            sku: '5844',
            project: '59',
            relevantVariants: [
              'elevation-fwd',
            ],
          },
        },
        interior: {
          d4xeirch0we2: {
            sku: '5836',
            project: '59',
            relevantVariants: [
              'denali',
            ],
            notCompatibleExteriorColors: [],
          },
          '5vktfJxuscn42': {
            sku: '5857',
            project: '59',
            relevantVariants: [
              'denali',
            ],
            notCompatibleExteriorColors: [],
          },
          nh3gtor4bx0g: {
            sku: '5859',
            project: '59',
            relevantVariants: [
              'at4',
            ],
            notCompatibleExteriorColors: [],
          },
          rjmviyk6rorz: {
            sku: '5848',
            project: '59',
            relevantVariants: [
              'elevation-awd',
            ],
            notCompatibleExteriorColors: [],
          },
          tju83k0v0vm1: {
            sku: '5852',
            project: '59',
            relevantVariants: [
              'elevation-awd',
            ],
            notCompatibleExteriorColors: [],
          },
          '5vktfxuscn42': {
            sku: '5848',
            project: '59',
            relevantVariants: [
              'elevation-fwd',
            ],
            notCompatibleExteriorColors: [],
          },
          '5vktfxkuscn42': {
            sku: '5852',
            project: '59',
            relevantVariants: [
              'elevation-fwd',
            ],
            notCompatibleExteriorColors: [],
          },
        },
      },
      features: {
        '3h3fjg5zh489': {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: [
            'denali',
          ],
          messages: [
            {
              message: 'SHADER_Front Grille',
              identifiers: [
                'common_exterior',
              ],
              waitForFulfill: false,
              cascade: false,
            },
            {
              message: 'Front Grille',
              identifiers: [
                'common_exterior',
              ],
              waitForFulfill: true,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        ngs1smpm2k89: {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: [
            'denali',
          ],
          messages: [
            {
              message: 'SHADER_19 in Wheels',
              identifiers: [
                'common_exterior',
              ],
              waitForFulfill: false,
              cascade: false,
            },
            {
              message: '19 in Wheels',
              identifiers: [
                'common_exterior',
              ],
              waitForFulfill: true,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        slfnh3hjd6s8: {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: [
            'denali',
          ],
          messages: [
            {
              message: 'Panaromic Sunroof',
              identifiers: [
                'common_exterior',
              ],
              waitForFulfill: true,
              cascade: false,
            },
            {
              message: 'SHADER_Panaromic Sunroof',
              identifiers: [
                'common_exterior',
              ],
              waitForFulfill: false,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        zeq7pry7mouo: {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: [
            'denali',
          ],
          messages: [
            {
              message: 'Headlamps',
              identifiers: [
                'common_exterior',
              ],
              waitForFulfill: true,
              cascade: false,
            },
            {
              message: 'SHADER_Headlamps',
              identifiers: [
                'common_exterior',
              ],
              waitForFulfill: false,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        qsf07vxusvhq: {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: [
            'denali',
          ],
          messages: [
            {
              message: 'Animated Taillamps',
              identifiers: [
                'common_exterior',
              ],
              waitForFulfill: true,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        marg8otdccyk: {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: [
            'denali',
          ],
          messages: [
            {
              message: 'WOM_Lights',
              identifiers: [
                'common_exterior',
              ],
              waitForFulfill: true,
              cascade: false,
            },
            {
              message: 'SHADER_WOM_Lights',
              identifiers: [
                'common_exterior',
              ],
              waitForFulfill: false,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        oxfitdgg14gk: {
          type: 'graphic',
          view: 'interior',
          relevantVariants: [
            'denali',
          ],
          messages: [
            {
              message: 'SHADER_Info Screen',
              identifiers: [
                'common_exterior',
              ],
              waitForFulfill: false,
              cascade: false,
            },
            {
              message: 'Info Screen',
              identifiers: [
                'common_exterior',
              ],
              waitForFulfill: true,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        ppj9rls95crn: {
          type: 'graphic',
          view: 'interior',
          relevantVariants: [
            'denali',
          ],
          messages: [
            {
              message: 'SHADER_Speedometer',
              identifiers: [
                'common_exterior',
              ],
              waitForFulfill: false,
              cascade: false,
            },
            {
              message: 'Speedometer',
              identifiers: [
                'common_exterior',
              ],
              waitForFulfill: true,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        okumo92efxcj: {
          type: 'graphic',
          view: 'interior',
          relevantVariants: [
            'denali',
          ],
          messages: [
            {
              message: 'SHADER_HUD',
              identifiers: [
                'common_exterior',
              ],
              waitForFulfill: false,
              cascade: false,
            },
            {
              message: 'HUD',
              identifiers: [
                'common_exterior',
              ],
              waitForFulfill: true,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        z5e0bv2uqipu: {
          type: 'graphic',
          view: 'interior',
          relevantVariants: [
            'denali',
          ],
          messages: [
            {
              message: 'Leather Seats',
              identifiers: [
                'common_exterior',
              ],
              waitForFulfill: true,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        yfvwasc6mj1o: {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: [
            'at4',
          ],
          messages: [
            {
              message: 'SHADER_Front Fascia',
              identifiers: [
                'common_exterior',
              ],
              waitForFulfill: false,
              cascade: false,
            },
            {
              message: 'Front Fascia',
              identifiers: [
                'common_exterior',
              ],
              waitForFulfill: true,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        pahngkghmoez: {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: [
            'at4',
          ],
          messages: [
            {
              message: 'SHADER_17 in Wheels',
              identifiers: [
                'common_exterior',
              ],
              waitForFulfill: false,
              cascade: false,
            },
            {
              message: '17 in Wheels',
              identifiers: [
                'common_exterior',
              ],
              waitForFulfill: true,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        e31d5aitcaee09: {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: [
            'at4',
          ],
          messages: [
            {
              message: 'Tow_Hooks',
              identifiers: [
                'common_exterior',
              ],
              waitForFulfill: true,
              cascade: false,
            },
            {
              message: 'SHADER_Tow_Hooks',
              identifiers: [
                'common_exterior',
              ],
              waitForFulfill: false,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        u236nerccehb: {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: [
            'at4',
          ],
          messages: [
            {
              message: 'Skid Plate',
              identifiers: [
                'common_exterior',
              ],
              waitForFulfill: true,
              cascade: false,
            },
            {
              message: 'SHADER_Skid Plate',
              identifiers: [
                'common_exterior',
              ],
              waitForFulfill: false,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        slfnh3hjd6s0: {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: [
            'at4',
          ],
          messages: [
            {
              message: 'Panaromic Sunroof',
              identifiers: [
                'common_exterior',
              ],
              waitForFulfill: true,
              cascade: false,
            },
            {
              message: 'SHADER_Panaromic Sunroof',
              identifiers: [
                'common_exterior',
              ],
              waitForFulfill: false,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        pl0emz85qxbq: {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: [
            'at4',
          ],
          messages: [
            {
              message: 'Headlamps',
              identifiers: [
                'common_exterior',
              ],
              waitForFulfill: true,
              cascade: false,
            },
            {
              message: 'SHADER_Headlamps',
              identifiers: [
                'common_exterior',
              ],
              waitForFulfill: false,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        e341dagcaee19: {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: [
            'at4',
          ],
          messages: [
            {
              message: 'Animated Taillamps',
              identifiers: [
                'common_exterior',
              ],
              waitForFulfill: true,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        dhj3daio9pk1: {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: [
            'at4',
          ],
          messages: [
            {
              message: 'WOM_Lights',
              identifiers: [
                'common_exterior',
              ],
              waitForFulfill: true,
              cascade: false,
            },
            {
              message: 'SHADER_WOM_Lights',
              identifiers: [
                'common_exterior',
              ],
              waitForFulfill: false,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        e31d5agotcaee09: {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: [
            'at4',
          ],
          messages: [
            {
              message: 'Power Liftgate',
              identifiers: [
                'common_exterior',
              ],
              waitForFulfill: true,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        rdkllscjmael: {
          type: 'graphic',
          view: 'interior',
          relevantVariants: [
            'at4',
          ],
          messages: [
            {
              message: 'SHADER_Info Screen',
              identifiers: [
                'common_exterior',
              ],
              waitForFulfill: false,
              cascade: false,
            },
            {
              message: 'Info Screen',
              identifiers: [
                'common_exterior',
              ],
              waitForFulfill: true,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        fvbmlowhohd5: {
          type: 'graphic',
          view: 'interior',
          relevantVariants: [
            'at4',
          ],
          messages: [
            {
              message: 'SHADER_Speedometer',
              identifiers: [
                'common_exterior',
              ],
              waitForFulfill: false,
              cascade: false,
            },
            {
              message: 'Speedometer',
              identifiers: [
                'common_exterior',
              ],
              waitForFulfill: true,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        '3ofodapu2ddp': {
          type: 'graphic',
          view: 'interior',
          relevantVariants: [
            'at4',
          ],
          messages: [
            {
              message: 'Unique AT4 Interior',
              identifiers: [
                'common_exterior',
              ],
              waitForFulfill: true,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        muey3bbku37k: {
          type: 'graphic',
          view: 'interior',
          relevantVariants: [
            'at4',
          ],
          messages: [
            {
              message: 'Premium Seating',
              identifiers: [
                'common_exterior',
              ],
              waitForFulfill: true,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        muey3bjbku37p: {
          type: 'graphic',
          view: 'interior',
          relevantVariants: [
            'at4',
          ],
          messages: [
            {
              message: 'SHADER_Selectable Drive Mode',
              identifiers: [
                'common_exterior',
              ],
              waitForFulfill: false,
              cascade: false,
            },
            {
              message: 'Selectable Drive Mode',
              identifiers: [
                'common_exterior',
              ],
              waitForFulfill: true,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        b5t3gnisyrtr: {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: [
            'elevation-awd',
          ],
          messages: [
            {
              message: 'SHADER_Front Fascia',
              identifiers: [
                'common_exterior',
              ],
              waitForFulfill: false,
              cascade: false,
            },
            {
              message: 'Front Fascia',
              identifiers: [
                'common_exterior',
              ],
              waitForFulfill: true,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        '921txph7ctk6': {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: [
            'elevation-awd',
          ],
          messages: [
            {
              message: 'SHADER_17 in Wheels',
              identifiers: [
                'common_exterior',
              ],
              waitForFulfill: false,
              cascade: false,
            },
            {
              message: '17 in Wheels',
              identifiers: [
                'common_exterior',
              ],
              waitForFulfill: true,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        tdkxif15is8l: {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: [
            'elevation-awd',
          ],
          messages: [
            {
              message: 'Headlamps',
              identifiers: [
                'common_exterior',
              ],
              waitForFulfill: true,
              cascade: false,
            },
            {
              message: 'SHADER_Headlamps',
              identifiers: [
                'common_exterior',
              ],
              waitForFulfill: false,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        '2n9ocuhy3xum': {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: [
            'elevation-awd',
          ],
          messages: [
            {
              message: 'SHADER_Taillamps',
              identifiers: [
                'common_exterior',
              ],
              waitForFulfill: false,
              cascade: false,
            },
            {
              message: 'Taillamps',
              identifiers: [
                'common_exterior',
              ],
              waitForFulfill: true,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        nlsuew7en922: {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: [
            'elevation-awd',
          ],
          messages: [
            {
              message: 'SHADER_Roof',
              identifiers: [
                'common_exterior',
              ],
              waitForFulfill: false,
              cascade: false,
            },
            {
              message: 'Roof',
              identifiers: [
                'common_exterior',
              ],
              waitForFulfill: true,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        s956dp42ni6i: {
          type: 'graphic',
          view: 'interior',
          relevantVariants: [
            'elevation-awd',
          ],
          messages: [
            {
              message: 'Transmission',
              identifiers: [
                'common_exterior',
              ],
              waitForFulfill: true,
              cascade: false,
            },
            {
              message: 'SHADER_Transmission',
              identifiers: [
                'common_exterior',
              ],
              waitForFulfill: false,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        '25l2ij6fie1s': {
          type: 'graphic',
          view: 'interior',
          relevantVariants: [
            'elevation-awd',
          ],
          messages: [
            {
              message: 'SHADER_Info Screen',
              identifiers: [
                'common_exterior',
              ],
              waitForFulfill: false,
              cascade: false,
            },
            {
              message: 'Info Screen',
              identifiers: [
                'common_exterior',
              ],
              waitForFulfill: true,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        n1tgoepqbnre: {
          type: 'graphic',
          view: 'interior',
          relevantVariants: [
            'elevation-awd',
          ],
          messages: [
            {
              message: 'SHADER_Speedometer',
              identifiers: [
                'common_exterior',
              ],
              waitForFulfill: false,
              cascade: false,
            },
            {
              message: 'Speedometer',
              identifiers: [
                'common_exterior',
              ],
              waitForFulfill: true,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        av8ukajwzjsm: {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: [
            'elevation-fwd',
          ],
          messages: [
            {
              message: 'SHADER_Front Fascia',
              identifiers: [
                'common_exterior',
              ],
              waitForFulfill: false,
              cascade: false,
            },
            {
              message: 'Front Fascia',
              identifiers: [
                'common_exterior',
              ],
              waitForFulfill: true,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        '56b99wbs39ki': {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: [
            'elevation-fwd',
          ],
          messages: [
            {
              message: 'SHADER_17 in Wheels',
              identifiers: [
                'common_exterior',
              ],
              waitForFulfill: false,
              cascade: false,
            },
            {
              message: '17 in Wheels',
              identifiers: [
                'common_exterior',
              ],
              waitForFulfill: true,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        e31dagcaee09: {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: [
            'elevation-fwd',
          ],
          messages: [
            {
              message: 'Headlamps',
              identifiers: [
                'common_exterior',
              ],
              waitForFulfill: true,
              cascade: false,
            },
            {
              message: 'SHADER_Headlamps',
              identifiers: [
                'common_exterior',
              ],
              waitForFulfill: false,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        e341dagcaee09: {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: [
            'elevation-fwd',
          ],
          messages: [
            {
              message: 'SHADER_Taillamps',
              identifiers: [
                'common_exterior',
              ],
              waitForFulfill: false,
              cascade: false,
            },
            {
              message: 'Taillamps',
              identifiers: [
                'common_exterior',
              ],
              waitForFulfill: true,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        e341raagcaee09: {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: [
            'elevation-fwd',
          ],
          messages: [
            {
              message: 'SHADER_Roof',
              identifiers: [
                'common_exterior',
              ],
              waitForFulfill: false,
              cascade: false,
            },
            {
              message: 'Roof',
              identifiers: [
                'common_exterior',
              ],
              waitForFulfill: true,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        e31d5agtcaee09: {
          type: 'graphic',
          view: 'interior',
          relevantVariants: [
            'elevation-fwd',
          ],
          messages: [
            {
              message: 'Transmission',
              identifiers: [
                'common_exterior',
              ],
              waitForFulfill: true,
              cascade: false,
            },
            {
              message: 'SHADER_Transmission',
              identifiers: [
                'common_exterior',
              ],
              waitForFulfill: false,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        e31dagcaeee09: {
          type: 'graphic',
          view: 'interior',
          relevantVariants: [
            'elevation-fwd',
          ],
          messages: [
            {
              message: 'SHADER_Info Screen',
              identifiers: [
                'common_exterior',
              ],
              waitForFulfill: false,
              cascade: false,
            },
            {
              message: 'Info Screen',
              identifiers: [
                'common_exterior',
              ],
              waitForFulfill: true,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        e31dagccaeee09: {
          type: 'graphic',
          view: 'interior',
          relevantVariants: [
            'elevation-fwd',
          ],
          messages: [
            {
              message: 'SHADER_Speedometer',
              identifiers: [
                'common_exterior',
              ],
              waitForFulfill: false,
              cascade: false,
            },
            {
              message: 'Speedometer',
              identifiers: [
                'common_exterior',
              ],
              waitForFulfill: true,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
      },
      accessories: {
        '8ylilfy10w5s': {
          view: 'exterior',
          groupId: '',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'Variant_Parts_Denali',
              identifiers: [
                'exterior-color',
              ],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'denali',
          ],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        whv4p5vjna3p: {
          view: 'exterior',
          groupId: 'denali-g0',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: '19In_Midnight Silver_Denali_Default',
              identifiers: [
                'common_exterior',
              ],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [
            {
              message: 'CAMERA_ALLOY',
              identifiers: [
                'common_exterior',
              ],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'denali',
          ],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        gzf6oq39rp8k: {
          view: 'interior',
          groupId: 'denali-g1',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'Sunroof_Single Tone',
              identifiers: [
                'exterior-color',
              ],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [
            {
              message: 'CAMERA_ROOF',
              identifiers: [
                'common_exterior',
              ],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'denali',
          ],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        mbxtmb9ivqay: {
          view: 'exterior',
          groupId: 'denali-g1',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'Sunroof_Dual Tone_Sterling_Metallic',
              identifiers: [
                'common_exterior',
              ],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [
            {
              message: 'CAMERA_ROOF',
              identifiers: [
                'common_exterior',
              ],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'denali',
          ],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        rf9u7yz5tuei: {
          view: 'exterior',
          groupId: 'denali-g0',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: '20In_After Midnight_Denali_Opt',
              identifiers: [
                'common_exterior',
              ],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [
            {
              message: 'CAMERA_ALLOY',
              identifiers: [
                'common_exterior',
              ],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          shaderMessages: [
            {
              message: 'SHADER_19 in Wheels',
              identifiers: [
                'common_exterior',
              ],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'denali',
          ],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        gy73ey0vzxv0: {
          view: 'exterior',
          groupId: '',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'ACC_GMC Emblem',
              identifiers: [
                'common_exterior',
              ],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [
            {
              message: 'Camera_ACC_GMC Emblem',
              identifiers: [
                'common_exterior',
              ],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          shaderMessages: [
            {
              message: 'SHADER_ACC_GMC Emblem',
              identifiers: [
                'common_exterior',
              ],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'denali',
          ],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        '0ozjd0gsso4h': {
          view: 'exterior',
          groupId: '',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'ACC_Roof Rack Cross Rails Black Pair',
              identifiers: [
                'common_exterior',
              ],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [
            {
              message: 'Camera_ACC_Roof Rack Cross Rails Black Pair',
              identifiers: [
                'common_exterior',
              ],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          shaderMessages: [
            {
              message: 'SHADER_ACC_Roof Rack Cross Rails Black Pair',
              identifiers: [
                'common_exterior',
              ],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'denali',
          ],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        vakcid2oshqg: {
          view: 'exterior',
          groupId: '',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'ACC_Black Splash Guards',
              identifiers: [
                'common_exterior',
              ],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [
            {
              message: 'Camera_ACC_Black Splash Guards',
              identifiers: [
                'common_exterior',
              ],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          shaderMessages: [
            {
              message: 'SHADER_ACC_Black Splash Guards',
              identifiers: [
                'common_exterior',
              ],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          affectedInteractionOnApply: {
            a9jk90o1h6fp: {
              add: false,
              snapToLastFrame: true,
            },
          },
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'denali',
          ],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        y38mjhotgigv: {
          view: 'exterior',
          groupId: 'denali-g2',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'ACC_Cargo Net_Black_Vertical_Envelope Style',
              identifiers: [
                'common_exterior',
              ],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [
            {
              message: 'Camera_ACC_Cargo Net_Black_Vertical_Envelope Style',
              identifiers: [
                'common_exterior',
              ],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          shaderMessages: [
            {
              message: 'SHADER_ACC_Cargo Net_Black_Vertical_Envelope Style',
              identifiers: [
                'common_exterior',
              ],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          affectedInteractionOnApply: {
            ygmre5317vts: {
              add: true,
              snapToLastFrame: true,
            },
          },
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'denali',
          ],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        jo36p6jnnsmp: {
          view: 'exterior',
          groupId: 'denali-g2',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'ACC_Cargo Area_Net_Black_Horizontal',
              identifiers: [
                'common_exterior',
              ],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [
            {
              message: 'Camera_ACC_Cargo Area_Net_Black_Horizontal',
              identifiers: [
                'common_exterior',
              ],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          shaderMessages: [
            {
              message: 'SHADER_ACC_Cargo Area_Net_Black_Horizontal',
              identifiers: [
                'common_exterior',
              ],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          affectedInteractionOnApply: {
            ygmre5317vts: {
              add: true,
              snapToLastFrame: true,
            },
          },
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'denali',
          ],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        ofs1ypszw83i: {
          view: 'interior',
          groupId: '',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'ACC_Front Liners_Jet Black_Front_and_Rear',
              identifiers: [
                'common_exterior',
              ],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [
            {
              message: 'Camera_ACC_Front Liners_Jet Black_Front_and_Rear',
              identifiers: [
                'common_exterior',
              ],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          shaderMessages: [
            {
              message: 'SHADER_ACC_Front Liners_Jet Black_Front_and_Rear',
              identifiers: [
                'common_exterior',
              ],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'denali',
          ],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        eqlc75r97q78: {
          view: 'exterior',
          groupId: '',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'ACC_Cargo Aear Floor Mat_Black_All-Weather_GMC',
              identifiers: [
                'common_exterior',
              ],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [
            {
              message: 'Camera_ACC_Cargo Aear Floor Mat_Black_All-Weather_GMC',
              identifiers: [
                'common_exterior',
              ],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          shaderMessages: [
            {
              message: 'SHADER_ACC_Cargo Aear Floor Mat_Black_All-Weather_GMC',
              identifiers: [
                'common_exterior',
              ],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          affectedInteractionOnApply: {
            ygmre5317vts: {
              add: true,
              snapToLastFrame: true,
            },
          },
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'denali',
          ],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        isd2yqtmgupfud: {
          view: 'exterior',
          groupId: 'elevation-fwd-g1',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'ACC_Cargo Organizer_Black_Collapsible',
              identifiers: [
                'common_exterior',
              ],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [
            {
              message: 'Camera_ACC_Cargo Organizer_Black_Collapsible',
              identifiers: [
                'common_exterior',
              ],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          shaderMessages: [
            {
              message: 'SHADER_ACC_Cargo Organizer_Black_Collapsible',
              identifiers: [
                'common_exterior',
              ],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          affectedInteractionOnApply: {
            smjhed8evi5i: {
              add: true,
              snapToLastFrame: true,
            },
          },
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'elevation-fwd',
          ],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        isd2yqtmgupden: {
          view: 'exterior',
          groupId: 'denali-g2',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'ACC_Cargo Organizer_Black_Collapsible',
              identifiers: [
                'common_exterior',
              ],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [
            {
              message: 'Camera_ACC_Cargo Organizer_Black_Collapsible',
              identifiers: [
                'common_exterior',
              ],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          shaderMessages: [
            {
              message: 'SHADER_ACC_Cargo Organizer_Black_Collapsible',
              identifiers: [
                'common_exterior',
              ],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          affectedInteractionOnApply: {
            ygmre5317vts: {
              add: true,
              snapToLastFrame: true,
            },
          },
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'denali',
          ],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        isd2yqtmgupat4: {
          view: 'exterior',
          groupId: 'at4-g1',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'ACC_Cargo Organizer_Black_Collapsible',
              identifiers: [
                'common_exterior',
              ],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [
            {
              message: 'Camera_ACC_Cargo Organizer_Black_Collapsible',
              identifiers: [
                'common_exterior',
              ],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          shaderMessages: [
            {
              message: 'SHADER_ACC_Cargo Organizer_Black_Collapsible',
              identifiers: [
                'common_exterior',
              ],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          affectedInteractionOnApply: {
            '739ajku514pk': {
              add: true,
              snapToLastFrame: true,
            },
          },
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'at4',
          ],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        isd2yqtmgupawd: {
          view: 'exterior',
          groupId: 'elevation-awd-g1',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'ACC_Cargo Organizer_Black_Collapsible',
              identifiers: [
                'common_exterior',
              ],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [
            {
              message: 'Camera_ACC_Cargo Organizer_Black_Collapsible',
              identifiers: [
                'common_exterior',
              ],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          shaderMessages: [
            {
              message: 'SHADER_ACC_Cargo Organizer_Black_Collapsible',
              identifiers: [
                'common_exterior',
              ],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          affectedInteractionOnApply: {
            '8kajaflga6ec': {
              add: true,
              snapToLastFrame: true,
            },
          },
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'elevation-awd',
          ],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        l6yakhg2fh10: {
          view: 'exterior',
          groupId: '',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'Variant_Parts_AT4',
              identifiers: [
                'exterior-color',
              ],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'at4',
          ],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        '9kjumt0f4al0': {
          view: 'interior',
          groupId: 'at4-g0',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'Sunroof_Single Tone',
              identifiers: [
                'exterior-color',
              ],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [
            {
              message: 'CAMERA_ROOF',
              identifiers: [
                'common_exterior',
              ],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'at4',
          ],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        p6z6t4grurfy: {
          view: 'exterior',
          groupId: 'at4-g0',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'Sunroof_Dual Tone_Sterling_Metallic',
              identifiers: [
                'common_exterior',
              ],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [
            {
              message: 'CAMERA_ROOF',
              identifiers: [
                'common_exterior',
              ],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'at4',
          ],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        isd8oqmgpfud: {
          view: 'exterior',
          groupId: '',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'ACC_AT4 Emblem',
              identifiers: [
                'common_exterior',
              ],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [
            {
              message: 'Camera_ACC_AT4 Emblem',
              identifiers: [
                'common_exterior',
              ],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          shaderMessages: [
            {
              message: 'SHADER_ACC_AT4 Emblem',
              identifiers: [
                'common_exterior',
              ],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          affectedInteractionOnApply: {
            dhtkbiouot0u: {
              add: false,
              snapToLastFrame: true,
            },
          },
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'at4',
          ],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        'isd8oqmgpfud-elevation-awd': {
          view: 'exterior',
          groupId: '',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'ACC_Terrain Emblem',
              identifiers: [
                'common_exterior',
              ],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [
            {
              message: 'Camera_ACC_Terrain Emblem',
              identifiers: [
                'common_exterior',
              ],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          shaderMessages: [
            {
              message: 'SHADER_ACC_Terrain Emblem',
              identifiers: [
                'common_exterior',
              ],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          affectedInteractionOnApply: {
            ctalf506071t: {
              add: false,
              snapToLastFrame: true,
            },
          },
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'elevation-awd',
            'elevation-fwd',
          ],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        sslppl6edd53: {
          view: 'exterior',
          groupId: '',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'ACC_GMC Emblem AT4 and Elevation',
              identifiers: [
                'common_exterior',
              ],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [
            {
              message: 'Camera_ACC_GMC Emblem AT4 and Elevation',
              identifiers: [
                'common_exterior',
              ],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          shaderMessages: [
            {
              message: 'SHADER_ACC_GMC Emblem AT4 and Elevation',
              identifiers: [
                'common_exterior',
              ],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'at4',
          ],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        x5anixg7je9n: {
          view: 'exterior',
          groupId: '',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'ACC_Roof Rack Cross Rails Black Pair',
              identifiers: [
                'common_exterior',
              ],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [
            {
              message: 'Camera_ACC_Roof Rack Cross Rails Black Pair',
              identifiers: [
                'common_exterior',
              ],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          shaderMessages: [
            {
              message: 'SHADER_ACC_Roof Rack Cross Rails Black Pair',
              identifiers: [
                'common_exterior',
              ],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'at4',
          ],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        jg6a3grjhx85: {
          view: 'exterior',
          groupId: '',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'ACC_Black Splash Guards',
              identifiers: [
                'common_exterior',
              ],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [
            {
              message: 'Camera_ACC_Black Splash Guards',
              identifiers: [
                'common_exterior',
              ],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          shaderMessages: [
            {
              message: 'SHADER_ACC_Black Splash Guards',
              identifiers: [
                'common_exterior',
              ],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          affectedInteractionOnApply: {
            dhtkbiouot0u: {
              add: false,
              snapToLastFrame: true,
            },
          },
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'at4',
          ],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        gvnaujmivz1v: {
          view: 'exterior',
          groupId: 'at4-g1',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'ACC_Cargo Net_Black_Vertical_Envelope Style',
              identifiers: [
                'common_exterior',
              ],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [
            {
              message: 'Camera_ACC_Cargo Net_Black_Vertical_Envelope Style',
              identifiers: [
                'common_exterior',
              ],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          shaderMessages: [
            {
              message: 'SHADER_ACC_Cargo Net_Black_Vertical_Envelope Style',
              identifiers: [
                'common_exterior',
              ],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          affectedInteractionOnApply: {
            '739ajku514pk': {
              add: true,
              snapToLastFrame: true,
            },
          },
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'at4',
          ],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        ef2994iszfi6: {
          view: 'exterior',
          groupId: 'at4-g1',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'ACC_Cargo Area_Net_Black_Horizontal',
              identifiers: [
                'common_exterior',
              ],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [
            {
              message: 'Camera_ACC_Cargo Area_Net_Black_Horizontal',
              identifiers: [
                'common_exterior',
              ],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          shaderMessages: [
            {
              message: 'SHADER_ACC_Cargo Area_Net_Black_Horizontal',
              identifiers: [
                'common_exterior',
              ],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          affectedInteractionOnApply: {
            '739ajku514pk': {
              add: true,
              snapToLastFrame: true,
            },
          },
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'at4',
          ],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        dx85isf3vy7c: {
          view: 'interior',
          groupId: '',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'ACC_Front Liners_Jet Black_Front_and_Rear',
              identifiers: [
                'common_exterior',
              ],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [
            {
              message: 'Camera_ACC_Front Liners_Jet Black_Front_and_Rear',
              identifiers: [
                'common_exterior',
              ],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          shaderMessages: [
            {
              message: 'SHADER_ACC_Front Liners_Jet Black_Front_and_Rear',
              identifiers: [
                'common_exterior',
              ],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'at4',
          ],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        isd9yqymgupfud: {
          view: 'exterior',
          groupId: '',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'ACC_Cargo Aear Floor Mat_Black_All-Weather_GMC',
              identifiers: [
                'common_exterior',
              ],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [
            {
              message: 'Camera_ACC_Cargo Aear Floor Mat_Black_All-Weather_GMC',
              identifiers: [
                'common_exterior',
              ],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          shaderMessages: [
            {
              message: 'SHADER_ACC_Cargo Aear Floor Mat_Black_All-Weather_GMC',
              identifiers: [
                'common_exterior',
              ],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          affectedInteractionOnApply: {
            '739ajku514pk': {
              add: true,
              snapToLastFrame: true,
            },
          },
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'at4',
            'elevation-awd',
            'elevation-fwd',
          ],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        '5g1n6syy87ra': {
          view: 'exterior',
          groupId: '',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'Variant_Parts_Elev_AWD',
              identifiers: [
                'exterior-color',
              ],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'elevation-awd',
          ],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        '4ee31pmiflm1': {
          view: 'interior',
          groupId: 'elevation-awd-g0',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'Roof_Single Tone',
              identifiers: [
                'exterior-color',
              ],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [
            {
              message: 'CAMERA_ROOF',
              identifiers: [
                'common_exterior',
              ],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'elevation-awd',
          ],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        erdpdhsmsp3q: {
          view: 'exterior',
          groupId: 'elevation-awd-g0',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'Roof_Dual Tone_Sterling_Metallic',
              identifiers: [
                'common_exterior',
              ],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [
            {
              message: 'CAMERA_ROOF',
              identifiers: [
                'common_exterior',
              ],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'elevation-awd',
          ],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        kkbvo88y5tjh: {
          view: 'exterior',
          groupId: '',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'ACC_GMC Emblem AT4 and Elevation',
              identifiers: [
                'common_exterior',
              ],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [
            {
              message: 'Camera_ACC_GMC Emblem AT4 and Elevation',
              identifiers: [
                'common_exterior',
              ],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          shaderMessages: [
            {
              message: 'SHADER_ACC_GMC Emblem AT4 and Elevation',
              identifiers: [
                'common_exterior',
              ],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'elevation-awd',
          ],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        '6rip5ck7x23i': {
          view: 'exterior',
          groupId: '',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'ACC_Roof Rack Cross Rails Black Pair',
              identifiers: [
                'common_exterior',
              ],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [
            {
              message: 'Camera_ACC_Roof Rack Cross Rails Black Pair',
              identifiers: [
                'common_exterior',
              ],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          shaderMessages: [
            {
              message: 'SHADER_ACC_Roof Rack Cross Rails Black Pair',
              identifiers: [
                'common_exterior',
              ],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'elevation-awd',
          ],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        pxhzgyqjul5i: {
          view: 'exterior',
          groupId: '',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'ACC_Black Splash Guards',
              identifiers: [
                'common_exterior',
              ],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [
            {
              message: 'Camera_ACC_Black Splash Guards',
              identifiers: [
                'common_exterior',
              ],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          shaderMessages: [
            {
              message: 'SHADER_ACC_Black Splash Guards',
              identifiers: [
                'common_exterior',
              ],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          affectedInteractionOnApply: {
            ctalf506071t: {
              add: false,
              snapToLastFrame: true,
            },
          },
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'elevation-awd',
          ],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        isez790x90nr: {
          view: 'exterior',
          groupId: 'elevation-awd-g1',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'ACC_Cargo Net_Black_Vertical_Envelope Style',
              identifiers: [
                'common_exterior',
              ],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [
            {
              message: 'Camera_ACC_Cargo Net_Black_Vertical_Envelope Style',
              identifiers: [
                'common_exterior',
              ],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          shaderMessages: [
            {
              message: 'SHADER_ACC_Cargo Net_Black_Vertical_Envelope Style',
              identifiers: [
                'common_exterior',
              ],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          affectedInteractionOnApply: {
            '8kajaflga6ec': {
              add: true,
              snapToLastFrame: true,
            },
          },
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'elevation-awd',
          ],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        '8fqmemi1c6s7': {
          view: 'exterior',
          groupId: 'elevation-awd-g1',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'ACC_Cargo Area_Net_Black_Horizontal',
              identifiers: [
                'common_exterior',
              ],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [
            {
              message: 'Camera_ACC_Cargo Area_Net_Black_Horizontal',
              identifiers: [
                'common_exterior',
              ],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          shaderMessages: [
            {
              message: 'SHADER_ACC_Cargo Area_Net_Black_Horizontal',
              identifiers: [
                'common_exterior',
              ],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          affectedInteractionOnApply: {
            '8kajaflga6ec': {
              add: true,
              snapToLastFrame: true,
            },
          },
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'elevation-awd',
          ],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        '25vopaky1sst': {
          view: 'interior',
          groupId: '',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'ACC_Front Liners_Jet Black_Front_and_Rear',
              identifiers: [
                'common_exterior',
              ],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [
            {
              message: 'Camera_ACC_Front Liners_Jet Black_Front_and_Rear',
              identifiers: [
                'common_exterior',
              ],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          shaderMessages: [
            {
              message: 'SHADER_ACC_Front Liners_Jet Black_Front_and_Rear',
              identifiers: [
                'common_exterior',
              ],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'elevation-awd',
          ],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        g7ttomupjamy: {
          view: 'exterior',
          groupId: 'elevation-awd-g2',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'WO_Black_Edition',
              identifiers: [
                'common_exterior',
              ],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [
            {
              message: 'CAMERA_EDITION',
              identifiers: [
                'common_exterior',
              ],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'elevation-awd',
          ],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        hx52xsy95wz6: {
          view: 'exterior',
          groupId: 'elevation-awd-g2',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'W_Black_Edition',
              identifiers: [
                'common_exterior',
              ],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [
            {
              message: 'CAMERA_EDITION',
              identifiers: [
                'common_exterior',
              ],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {
            ctalf506071t: {
              add: false,
              snapToLastFrame: true,
            },
            '8kajaflga6ec': {
              add: false,
              snapToLastFrame: true,
            },
          },
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'elevation-awd',
          ],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        k1lhqq1uv4kc: {
          view: 'exterior',
          groupId: 'elevation-awd-g3',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: '17Inch Grazen Metallic, Machined Alluminium',
              identifiers: [
                'common_exterior',
              ],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [
            {
              message: 'CAMERA_EDITION',
              identifiers: [
                'common_exterior',
              ],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'elevation-awd',
          ],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        m32slxx4hjfk: {
          view: 'exterior',
          groupId: 'elevation-awd-g3',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: '19Inch Gloss Black Aluminium painted',
              identifiers: [
                'common_exterior',
              ],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [
            {
              message: 'CAMERA_EDITION',
              identifiers: [
                'common_exterior',
              ],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'elevation-awd',
          ],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        m32slccxx4hjfk: {
          view: 'exterior',
          groupId: '',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'W_Black_Edition_AWD_Logo',
              identifiers: [
                'common_exterior',
              ],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'elevation-awd',
          ],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        '3w06jsi5oinw': {
          view: 'exterior',
          groupId: '',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'Variant_Parts_Elev_FWD',
              identifiers: [
                'exterior-color',
              ],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'elevation-fwd',
          ],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        dpsosp5gxrx3: {
          view: 'interior',
          groupId: 'elevation-fwd-g0',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'Roof_Single Tone',
              identifiers: [
                'exterior-color',
              ],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [
            {
              message: 'CAMERA_ROOF',
              identifiers: [
                'common_exterior',
              ],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'elevation-fwd',
          ],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        prnt5nsa6jxn: {
          view: 'exterior',
          groupId: 'elevation-fwd-g0',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'Roof_Dual Tone_Sterling_Metallic',
              identifiers: [
                'common_exterior',
              ],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [
            {
              message: 'CAMERA_ROOF',
              identifiers: [
                'common_exterior',
              ],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'elevation-fwd',
          ],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        isd8oqmgupfud: {
          view: 'exterior',
          groupId: '',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'ACC_GMC Emblem AT4 and Elevation',
              identifiers: [
                'common_exterior',
              ],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [
            {
              message: 'Camera_ACC_GMC Emblem AT4 and Elevation',
              identifiers: [
                'common_exterior',
              ],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          shaderMessages: [
            {
              message: 'SHADER_ACC_GMC Emblem AT4 and Elevation',
              identifiers: [
                'common_exterior',
              ],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'elevation-fwd',
          ],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        isd8oqrmgupfud: {
          view: 'exterior',
          groupId: '',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'ACC_Roof Rack Cross Rails Black Pair',
              identifiers: [
                'common_exterior',
              ],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [
            {
              message: 'Camera_ACC_Roof Rack Cross Rails Black Pair',
              identifiers: [
                'common_exterior',
              ],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          shaderMessages: [
            {
              message: 'SHADER_ACC_Roof Rack Cross Rails Black Pair',
              identifiers: [
                'common_exterior',
              ],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'elevation-fwd',
          ],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        isd8oqymgupfud: {
          view: 'exterior',
          groupId: '',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'ACC_Black Splash Guards',
              identifiers: [
                'common_exterior',
              ],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [
            {
              message: 'Camera_ACC_Black Splash Guards',
              identifiers: [
                'common_exterior',
              ],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          shaderMessages: [
            {
              message: 'SHADER_ACC_Black Splash Guards',
              identifiers: [
                'common_exterior',
              ],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          affectedInteractionOnApply: {
            nw7ayiomff7o: {
              add: false,
              snapToLastFrame: true,
            },
          },
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'elevation-fwd',
          ],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        isd5oqymgupfud: {
          view: 'exterior',
          groupId: 'elevation-fwd-g1',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'ACC_Cargo Net_Black_Vertical_Envelope Style',
              identifiers: [
                'common_exterior',
              ],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [
            {
              message: 'Camera_ACC_Cargo Net_Black_Vertical_Envelope Style',
              identifiers: [
                'common_exterior',
              ],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          shaderMessages: [
            {
              message: 'SHADER_ACC_Cargo Net_Black_Vertical_Envelope Style',
              identifiers: [
                'common_exterior',
              ],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          affectedInteractionOnApply: {
            smjhed8evi5i: {
              add: true,
              snapToLastFrame: true,
            },
          },
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'elevation-fwd',
          ],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        isd2oqymgupfud: {
          view: 'exterior',
          groupId: 'elevation-fwd-g1',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'ACC_Cargo Area_Net_Black_Horizontal',
              identifiers: [
                'common_exterior',
              ],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [
            {
              message: 'Camera_ACC_Cargo Area_Net_Black_Horizontal',
              identifiers: [
                'common_exterior',
              ],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          shaderMessages: [
            {
              message: 'SHADER_ACC_Cargo Area_Net_Black_Horizontal',
              identifiers: [
                'common_exterior',
              ],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          affectedInteractionOnApply: {
            smjhed8evi5i: {
              add: true,
              snapToLastFrame: true,
            },
          },
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'elevation-fwd',
          ],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        isd9oqymgupfud: {
          view: 'interior',
          groupId: '',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'ACC_Front Liners_Jet Black_Front_and_Rear',
              identifiers: [
                'common_exterior',
              ],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [
            {
              message: 'Camera_ACC_Front Liners_Jet Black_Front_and_Rear',
              identifiers: [
                'common_exterior',
              ],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          shaderMessages: [
            {
              message: 'SHADER_ACC_Front Liners_Jet Black_Front_and_Rear',
              identifiers: [
                'common_exterior',
              ],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'elevation-fwd',
          ],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        isd10yqtmgupfud: {
          view: 'exterior',
          groupId: 'elevation-fwd-g2',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'WO_Black_Edition',
              identifiers: [
                'common_exterior',
              ],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [
            {
              message: 'CAMERA_EDITION',
              identifiers: [
                'common_exterior',
              ],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'elevation-fwd',
          ],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        isd10yuqtmgupfud: {
          view: 'exterior',
          groupId: 'elevation-fwd-g2',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'W_Black_Edition',
              identifiers: [
                'common_exterior',
              ],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [
            {
              message: 'CAMERA_EDITION',
              identifiers: [
                'common_exterior',
              ],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {
            nw7ayiomff7o: {
              add: false,
              snapToLastFrame: true,
            },
            smjhed8evi5i: {
              add: false,
              snapToLastFrame: true,
            },
          },
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'elevation-fwd',
          ],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        isd105yuqtmgupfud: {
          view: 'exterior',
          groupId: 'elevation-fwd-g3',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: '17Inch Grazen Metallic, Machined Alluminium',
              identifiers: [
                'common_exterior',
              ],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [
            {
              message: 'CAMERA_EDITION',
              identifiers: [
                'common_exterior',
              ],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'elevation-fwd',
          ],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        isd10y5uqtmgupfud: {
          view: 'exterior',
          groupId: 'elevation-fwd-g3',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: '19Inch Gloss Black Aluminium painted',
              identifiers: [
                'common_exterior',
              ],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [
            {
              message: 'CAMERA_EDITION',
              identifiers: [
                'common_exterior',
              ],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'elevation-fwd',
          ],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
      },
      packages: {
        a1rk6oa07y0e: {
          groupId: 'elevation-awd-pkg0',
          accessoryIds: [
            'hx52xsy95wz6',
            'm32slxx4hjfk',
            'm32slccxx4hjfk',
          ],
          dependencyPackages: [],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
          relevantVariants: [
            'elevation-awd',
          ],
        },
        x7vtyriufcgr0: {
          groupId: 'elevation-fwd-pkg0',
          accessoryIds: [
            'isd10yuqtmgupfud',
            'isd10y5uqtmgupfud',
          ],
          dependencyPackages: [],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
          relevantVariants: [
            'elevation-fwd',
          ],
        },
      },
      interactions: {
        a9jk90o1h6fp: {
          type: 'basic',
          view: [
            'exterior',
            'interior',
          ],
          startMessages: [
            {
              message: 'DOORS_OPEN',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'common_interior',
                'interior-color',
                'variants_parts',
                'bed_variant',
                'optional',
              ],
              waitForFulfill: false,
              cascade: true,
            },
          ],
          reverseMessages: [
            {
              message: 'DOORS_CLOSE',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'common_interior',
                'interior-color',
                'variants_parts',
                'bed_variant',
                'optional',
              ],
              waitForFulfill: false,
              cascade: true,
            },
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 4.0032,
                beta: 1.3201,
                radius: 5.1617,
                isBlend: true,
                blendInSeconds: 1.5,
              },
            },
            interiorCamera: {
              type: 'interior',
              messages: {
                alpha: 3.5141,
                beta: 1.4083,
                radius: 0.1,
                isBlend: true,
                blendInSeconds: 1.5,
              },
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {
                alpha: 3.4327,
                beta: 1.3211,
                radius: 0.1,
                isBlend: true,
                blendInSeconds: 1.5,
              },
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {
                alpha: 5.0385,
                beta: 1.448,
                radius: 0.1,
                isBlend: true,
                blendInSeconds: 1.5,
              },
            },
          },
          relevantVariants: [
            'denali',
          ],
        },
        ygmre5317vts: {
          type: 'basic',
          view: [
            'exterior',
          ],
          startMessages: [
            {
              message: 'TAILGATE_OPEN',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'common_interior',
                'interior-color',
                'variants_parts',
                'bed_variant',
                'optional',
              ],
              waitForFulfill: false,
              cascade: true,
            },
          ],
          reverseMessages: [
            {
              message: 'TAILGATE_CLOSE',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'common_interior',
                'interior-color',
                'variants_parts',
                'bed_variant',
                'optional',
              ],
              waitForFulfill: false,
              cascade: true,
            },
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 4.71,
                beta: 1.3951,
                radius: 5.1465,
                isBlend: true,
                blendInSeconds: 1.5,
              },
            },
            interiorCamera: {
              type: 'interior',
              messages: {},
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {},
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {},
            },
          },
          relevantVariants: [
            'denali',
          ],
        },
        zye1e1vcwmvc: {
          type: 'basic',
          view: [
            'exterior',
          ],
          startMessages: [
            {
              message: 'SUNROOF_SHADE_OPEN',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'common_interior',
                'interior-color',
                'variants_parts',
                'bed_variant',
                'optional',
              ],
              waitForFulfill: false,
              cascade: false,
            },
          ],
          reverseMessages: [
            {
              message: 'SUNROOF_SHADE_CLOSE',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'common_interior',
                'interior-color',
                'variants_parts',
                'bed_variant',
                'optional',
              ],
              waitForFulfill: false,
              cascade: false,
            },
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 4.7049,
                beta: 0.115,
                radius: 3.2,
                isBlend: true,
                blendInSeconds: 1.5,
              },
            },
            interiorCamera: {
              type: 'interior',
              messages: {
                alpha: 4.7145,
                beta: 3.1212,
                radius: 0.1,
                isBlend: true,
                blendInSeconds: 1.5,
              },
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {
                alpha: 4.7222,
                beta: 1.8799,
                radius: 0.1,
                isBlend: true,
                blendInSeconds: 1.5,
              },
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {
                alpha: 4.7036,
                beta: 1.5732,
                radius: 0.1,
                isBlend: true,
                blendInSeconds: 1.5,
              },
            },
          },
          relevantVariants: [
            'denali',
          ],
        },
        q5wycu9jmjsc: {
          type: 'basic-light',
          view: [
            'exterior',
          ],
          startMessages: [
            {
              message: 'HEADLIGHT_GLOW',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'common_interior',
                'interior-color',
                'variants_parts',
                'bed_variant',
                'optional',
              ],
              waitForFulfill: false,
              cascade: false,
            },
          ],
          reverseMessages: [
            {
              message: 'HEADLIGHT_GLOW',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'common_interior',
                'interior-color',
                'variants_parts',
                'bed_variant',
                'optional',
              ],
              waitForFulfill: false,
              cascade: false,
            },
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 1.573,
                beta: 1.4729,
                radius: 4.3405,
                isBlend: true,
                blendInSeconds: 1.5,
              },
            },
            interiorCamera: {
              type: 'interior',
              messages: {},
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {},
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {},
            },
          },
          relevantVariants: [
            'denali',
          ],
        },
        ehdd0bdxbb0i: {
          type: 'basic-light',
          view: [
            'exterior',
          ],
          startMessages: [
            {
              message: 'DRL_GLOW',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'common_interior',
                'interior-color',
                'variants_parts',
                'bed_variant',
                'optional',
              ],
              waitForFulfill: false,
              cascade: false,
            },
          ],
          reverseMessages: [
            {
              message: 'DRL_GLOW',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'common_interior',
                'interior-color',
                'variants_parts',
                'bed_variant',
                'optional',
              ],
              waitForFulfill: false,
              cascade: false,
            },
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 1.573,
                beta: 1.473,
                radius: 4.7,
                isBlend: true,
                blendInSeconds: 1.5,
              },
            },
            interiorCamera: {
              type: 'interior',
              messages: {},
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {},
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {},
            },
          },
          relevantVariants: [
            'denali',
          ],
        },
        yi26t2yj1ipi: {
          type: 'basic-light',
          view: [
            'exterior',
          ],
          startMessages: [
            {
              message: 'TAILLIGHT_GLOW',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'common_interior',
                'interior-color',
                'variants_parts',
                'bed_variant',
                'optional',
              ],
              waitForFulfill: false,
              cascade: false,
            },
          ],
          reverseMessages: [
            {
              message: 'TAILLIGHT_GLOW',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'common_interior',
                'interior-color',
                'variants_parts',
                'bed_variant',
                'optional',
              ],
              waitForFulfill: false,
              cascade: false,
            },
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 4.71,
                beta: 1.3951,
                radius: 5.1465,
                isBlend: true,
                blendInSeconds: 1.5,
              },
            },
            interiorCamera: {
              type: 'interior',
              messages: {},
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {},
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {},
            },
          },
          relevantVariants: [
            'denali',
          ],
        },
        dhtkbiouot0u: {
          type: 'basic',
          view: [
            'exterior',
            'interior',
          ],
          startMessages: [
            {
              message: 'DOORS_OPEN',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'common_interior',
                'interior-color',
                'variants_parts',
                'bed_variant',
                'optional',
              ],
              waitForFulfill: false,
              cascade: true,
            },
          ],
          reverseMessages: [
            {
              message: 'DOORS_CLOSE',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'common_interior',
                'interior-color',
                'variants_parts',
                'bed_variant',
                'optional',
              ],
              waitForFulfill: false,
              cascade: true,
            },
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 4.0032,
                beta: 1.3201,
                radius: 5.1617,
                isBlend: true,
                blendInSeconds: 1.5,
              },
            },
            interiorCamera: {
              type: 'interior',
              messages: {
                alpha: 3.5141,
                beta: 1.4083,
                radius: 0.1,
                isBlend: true,
                blendInSeconds: 1.5,
              },
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {
                alpha: 3.4327,
                beta: 1.3211,
                radius: 0.1,
                isBlend: true,
                blendInSeconds: 1.5,
              },
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {
                alpha: 5.0385,
                beta: 1.448,
                radius: 0.1,
                isBlend: true,
                blendInSeconds: 1.5,
              },
            },
          },
          relevantVariants: [
            'at4',
          ],
        },
        '739ajku514pk': {
          type: 'basic',
          view: [
            'exterior',
          ],
          startMessages: [
            {
              message: 'TAILGATE_OPEN',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'common_interior',
                'interior-color',
                'variants_parts',
                'bed_variant',
                'optional',
              ],
              waitForFulfill: false,
              cascade: true,
            },
          ],
          reverseMessages: [
            {
              message: 'TAILGATE_CLOSE',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'common_interior',
                'interior-color',
                'variants_parts',
                'bed_variant',
                'optional',
              ],
              waitForFulfill: false,
              cascade: true,
            },
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 4.71,
                beta: 1.3951,
                radius: 5.1465,
                isBlend: true,
                blendInSeconds: 1.5,
              },
            },
            interiorCamera: {
              type: 'interior',
              messages: {},
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {},
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {},
            },
          },
          relevantVariants: [
            'at4',
          ],
        },
        '7x0dl7w7ygmd': {
          type: 'basic',
          view: [
            'exterior',
          ],
          startMessages: [
            {
              message: 'SUNROOF_SHADE_OPEN',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'common_interior',
                'interior-color',
                'variants_parts',
                'bed_variant',
                'optional',
              ],
              waitForFulfill: false,
              cascade: false,
            },
          ],
          reverseMessages: [
            {
              message: 'SUNROOF_SHADE_CLOSE',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'common_interior',
                'interior-color',
                'variants_parts',
                'bed_variant',
                'optional',
              ],
              waitForFulfill: false,
              cascade: false,
            },
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 4.7049,
                beta: 0.115,
                radius: 3.2,
                isBlend: true,
                blendInSeconds: 1.5,
              },
            },
            interiorCamera: {
              type: 'interior',
              messages: {
                alpha: 4.7145,
                beta: 3.1212,
                radius: 0.1,
                isBlend: true,
                blendInSeconds: 1.5,
              },
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {
                alpha: 4.7222,
                beta: 1.8799,
                radius: 0.1,
                isBlend: true,
                blendInSeconds: 1.5,
              },
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {
                alpha: 4.7036,
                beta: 1.5732,
                radius: 0.1,
                isBlend: true,
                blendInSeconds: 1.5,
              },
            },
          },
          relevantVariants: [
            'at4',
          ],
        },
        o0nbblk83v7e: {
          type: 'basic-light',
          view: [
            'exterior',
          ],
          startMessages: [
            {
              message: 'HEADLIGHT_GLOW',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'common_interior',
                'interior-color',
                'variants_parts',
                'bed_variant',
                'optional',
              ],
              waitForFulfill: false,
              cascade: false,
            },
          ],
          reverseMessages: [
            {
              message: 'HEADLIGHT_GLOW',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'common_interior',
                'interior-color',
                'variants_parts',
                'bed_variant',
                'optional',
              ],
              waitForFulfill: false,
              cascade: false,
            },
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 1.573,
                beta: 1.4729,
                radius: 4.3405,
                isBlend: true,
                blendInSeconds: 1.5,
              },
            },
            interiorCamera: {
              type: 'interior',
              messages: {},
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {},
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {},
            },
          },
          relevantVariants: [
            'at4',
          ],
        },
        '4pnfkr4uzi0w': {
          type: 'basic-light',
          view: [
            'exterior',
          ],
          startMessages: [
            {
              message: 'DRL_GLOW',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'common_interior',
                'interior-color',
                'variants_parts',
                'bed_variant',
                'optional',
              ],
              waitForFulfill: false,
              cascade: false,
            },
          ],
          reverseMessages: [
            {
              message: 'DRL_GLOW',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'common_interior',
                'interior-color',
                'variants_parts',
                'bed_variant',
                'optional',
              ],
              waitForFulfill: false,
              cascade: false,
            },
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 1.573,
                beta: 1.473,
                radius: 4.7,
                isBlend: true,
                blendInSeconds: 1.5,
              },
            },
            interiorCamera: {
              type: 'interior',
              messages: {},
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {},
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {},
            },
          },
          relevantVariants: [
            'at4',
          ],
        },
        jm7u9xug9nel: {
          type: 'basic-light',
          view: [
            'exterior',
          ],
          startMessages: [
            {
              message: 'TAILLIGHT_GLOW',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'common_interior',
                'interior-color',
                'variants_parts',
                'bed_variant',
                'optional',
              ],
              waitForFulfill: false,
              cascade: false,
            },
          ],
          reverseMessages: [
            {
              message: 'TAILLIGHT_GLOW',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'common_interior',
                'interior-color',
                'variants_parts',
                'bed_variant',
                'optional',
              ],
              waitForFulfill: false,
              cascade: false,
            },
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 4.71,
                beta: 1.3951,
                radius: 5.1465,
                isBlend: true,
                blendInSeconds: 1.5,
              },
            },
            interiorCamera: {
              type: 'interior',
              messages: {},
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {},
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {},
            },
          },
          relevantVariants: [
            'at4',
          ],
        },
        ctalf506071t: {
          type: 'basic',
          view: [
            'exterior',
            'interior',
          ],
          startMessages: [
            {
              message: 'DOORS_OPEN',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'common_interior',
                'interior-color',
                'variants_parts',
                'bed_variant',
                'optional',
              ],
              waitForFulfill: false,
              cascade: true,
            },
          ],
          reverseMessages: [
            {
              message: 'DOORS_CLOSE',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'common_interior',
                'interior-color',
                'variants_parts',
                'bed_variant',
                'optional',
              ],
              waitForFulfill: false,
              cascade: true,
            },
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 4.0032,
                beta: 1.3201,
                radius: 5.1617,
                isBlend: true,
                blendInSeconds: 1.5,
              },
            },
            interiorCamera: {
              type: 'interior',
              messages: {
                alpha: 3.5141,
                beta: 1.4083,
                radius: 0.1,
                isBlend: true,
                blendInSeconds: 1.5,
              },
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {
                alpha: 3.4327,
                beta: 1.3211,
                radius: 0.1,
                isBlend: true,
                blendInSeconds: 1.5,
              },
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {
                alpha: 5.0385,
                beta: 1.448,
                radius: 0.1,
                isBlend: true,
                blendInSeconds: 1.5,
              },
            },
          },
          relevantVariants: [
            'elevation-awd',
          ],
        },
        '8kajaflga6ec': {
          type: 'basic',
          view: [
            'exterior',
          ],
          startMessages: [
            {
              message: 'TAILGATE_OPEN',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'common_interior',
                'interior-color',
                'variants_parts',
                'bed_variant',
                'optional',
              ],
              waitForFulfill: false,
              cascade: true,
            },
          ],
          reverseMessages: [
            {
              message: 'TAILGATE_CLOSE',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'common_interior',
                'interior-color',
                'variants_parts',
                'bed_variant',
                'optional',
              ],
              waitForFulfill: false,
              cascade: true,
            },
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 4.71,
                beta: 1.3951,
                radius: 5.1465,
                isBlend: true,
                blendInSeconds: 1.5,
              },
            },
            interiorCamera: {
              type: 'interior',
              messages: {},
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {},
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {},
            },
          },
          relevantVariants: [
            'elevation-awd',
          ],
        },
        pdnnbzpcq1m1: {
          type: 'basic-light',
          view: [
            'exterior',
          ],
          startMessages: [
            {
              message: 'HEADLIGHT_GLOW',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'common_interior',
                'interior-color',
                'variants_parts',
                'bed_variant',
                'optional',
              ],
              waitForFulfill: false,
              cascade: false,
            },
          ],
          reverseMessages: [
            {
              message: 'HEADLIGHT_GLOW',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'common_interior',
                'interior-color',
                'variants_parts',
                'bed_variant',
                'optional',
              ],
              waitForFulfill: false,
              cascade: false,
            },
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 1.573,
                beta: 1.4729,
                radius: 4.3405,
                isBlend: true,
                blendInSeconds: 1.5,
              },
            },
            interiorCamera: {
              type: 'interior',
              messages: {},
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {},
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {},
            },
          },
          relevantVariants: [
            'elevation-awd',
          ],
        },
        '1qkd8e3dqxb2': {
          type: 'basic-light',
          view: [
            'exterior',
          ],
          startMessages: [
            {
              message: 'DRL_GLOW',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'common_interior',
                'interior-color',
                'variants_parts',
                'bed_variant',
                'optional',
              ],
              waitForFulfill: false,
              cascade: false,
            },
          ],
          reverseMessages: [
            {
              message: 'DRL_GLOW',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'common_interior',
                'interior-color',
                'variants_parts',
                'bed_variant',
                'optional',
              ],
              waitForFulfill: false,
              cascade: false,
            },
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 1.573,
                beta: 1.473,
                radius: 4.7,
                isBlend: true,
                blendInSeconds: 1.5,
              },
            },
            interiorCamera: {
              type: 'interior',
              messages: {},
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {},
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {},
            },
          },
          relevantVariants: [
            'elevation-awd',
          ],
        },
        '9q3d5sn71365': {
          type: 'basic-light',
          view: [
            'exterior',
          ],
          startMessages: [
            {
              message: 'TAILLIGHT_GLOW',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'common_interior',
                'interior-color',
                'variants_parts',
                'bed_variant',
                'optional',
              ],
              waitForFulfill: false,
              cascade: false,
            },
          ],
          reverseMessages: [
            {
              message: 'TAILLIGHT_GLOW',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'common_interior',
                'interior-color',
                'variants_parts',
                'bed_variant',
                'optional',
              ],
              waitForFulfill: false,
              cascade: false,
            },
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 4.71,
                beta: 1.3951,
                radius: 5.1465,
                isBlend: true,
                blendInSeconds: 1.5,
              },
            },
            interiorCamera: {
              type: 'interior',
              messages: {},
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {},
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {},
            },
          },
          relevantVariants: [
            'elevation-awd',
          ],
        },
        nw7ayiomff7o: {
          type: 'basic',
          view: [
            'exterior',
            'interior',
          ],
          startMessages: [
            {
              message: 'DOORS_OPEN',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'common_interior',
                'interior-color',
                'variants_parts',
                'bed_variant',
                'optional',
              ],
              waitForFulfill: false,
              cascade: true,
            },
          ],
          reverseMessages: [
            {
              message: 'DOORS_CLOSE',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'common_interior',
                'interior-color',
                'variants_parts',
                'bed_variant',
                'optional',
              ],
              waitForFulfill: false,
              cascade: true,
            },
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 4.0032,
                beta: 1.3201,
                radius: 5.1617,
                isBlend: true,
                blendInSeconds: 1.5,
              },
            },
            interiorCamera: {
              type: 'interior',
              messages: {
                alpha: 3.5141,
                beta: 1.4083,
                radius: 0.1,
                isBlend: true,
                blendInSeconds: 1.5,
              },
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {
                alpha: 3.4327,
                beta: 1.3211,
                radius: 0.1,
                isBlend: true,
                blendInSeconds: 1.5,
              },
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {
                alpha: 5.0385,
                beta: 1.448,
                radius: 0.1,
                isBlend: true,
                blendInSeconds: 1.5,
              },
            },
          },
          relevantVariants: [
            'elevation-fwd',
          ],
        },
        smjhed8evi5i: {
          type: 'basic',
          view: [
            'exterior',
          ],
          startMessages: [
            {
              message: 'TAILGATE_OPEN',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'common_interior',
                'interior-color',
                'variants_parts',
                'bed_variant',
                'optional',
              ],
              waitForFulfill: false,
              cascade: true,
            },
          ],
          reverseMessages: [
            {
              message: 'TAILGATE_CLOSE',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'common_interior',
                'interior-color',
                'variants_parts',
                'bed_variant',
                'optional',
              ],
              waitForFulfill: false,
              cascade: true,
            },
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 4.71,
                beta: 1.3951,
                radius: 5.1465,
                isBlend: true,
                blendInSeconds: 1.5,
              },
            },
            interiorCamera: {
              type: 'interior',
              messages: {},
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {},
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {},
            },
          },
          relevantVariants: [
            'elevation-fwd',
          ],
        },
        z50uy8f03jh7: {
          type: 'basic-light',
          view: [
            'exterior',
          ],
          startMessages: [
            {
              message: 'HEADLIGHT_GLOW',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'common_interior',
                'interior-color',
                'variants_parts',
                'bed_variant',
                'optional',
              ],
              waitForFulfill: false,
              cascade: false,
            },
          ],
          reverseMessages: [
            {
              message: 'HEADLIGHT_GLOW',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'common_interior',
                'interior-color',
                'variants_parts',
                'bed_variant',
                'optional',
              ],
              waitForFulfill: false,
              cascade: false,
            },
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 1.573,
                beta: 1.4729,
                radius: 4.3405,
                isBlend: true,
                blendInSeconds: 1.5,
              },
            },
            interiorCamera: {
              type: 'interior',
              messages: {},
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {},
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {},
            },
          },
          relevantVariants: [
            'elevation-fwd',
          ],
        },
        '14eisbljp9pi': {
          type: 'basic-light',
          view: [
            'exterior',
          ],
          startMessages: [
            {
              message: 'DRL_GLOW',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'common_interior',
                'interior-color',
                'variants_parts',
                'bed_variant',
                'optional',
              ],
              waitForFulfill: false,
              cascade: false,
            },
          ],
          reverseMessages: [
            {
              message: 'DRL_GLOW',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'common_interior',
                'interior-color',
                'variants_parts',
                'bed_variant',
                'optional',
              ],
              waitForFulfill: false,
              cascade: false,
            },
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 1.573,
                beta: 1.473,
                radius: 4.7,
                isBlend: true,
                blendInSeconds: 1.5,
              },
            },
            interiorCamera: {
              type: 'interior',
              messages: {},
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {},
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {},
            },
          },
          relevantVariants: [
            'elevation-fwd',
          ],
        },
        '1vqrly7ngbhv': {
          type: 'basic-light',
          view: [
            'exterior',
          ],
          startMessages: [
            {
              message: 'TAILLIGHT_GLOW',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'common_interior',
                'interior-color',
                'variants_parts',
                'bed_variant',
                'optional',
              ],
              waitForFulfill: false,
              cascade: false,
            },
          ],
          reverseMessages: [
            {
              message: 'TAILLIGHT_GLOW',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'common_interior',
                'interior-color',
                'variants_parts',
                'bed_variant',
                'optional',
              ],
              waitForFulfill: false,
              cascade: false,
            },
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 4.71,
                beta: 1.3951,
                radius: 5.1465,
                isBlend: true,
                blendInSeconds: 1.5,
              },
            },
            interiorCamera: {
              type: 'interior',
              messages: {},
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {},
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {},
            },
          },
          relevantVariants: [
            'elevation-fwd',
          ],
        },
      },
      hotspots: {
        exteriorCamera: {
          type: 'exterior',
          messages: {
            fov: 0.8,
            alpha: 2.02,
            beta: 1.47,
            radius: 5.7,
            lowerAlphaLimit: null,
            upperAlphaLimit: null,
            lowerBetaLimit: 0.1,
            upperBetaLimit: 1.6,
            lowerRadiusLimit: 3.2,
            upperRadiusLimit: 6.7,
            target: {
              x: 0,
              y: 0.65,
              z: 0,
            },
            isFovZoomModeOn: false,
          },
        },
        interiorCamera: {
          type: 'interior',
          messages: {
            message: 'INT_DEFAULT_CAMERA',
            identifiers: [
              'common_exterior',
            ],
          },
        },
        interiorCamera_1: {
          type: 'interior',
          messages: {
            message: 'INT_DEFAULT_CAMERA_2',
            identifiers: [
              'common_exterior',
            ],
          },
        },
        interiorCamera_2: {
          type: 'interior',
          messages: {},
        },
      },
      usdzPathWithVariable: '',
    },
  },
};
